import { makeStyles } from '@material-ui/core/styles';

const useStyles = makeStyles(theme => ({
  overlay: {
    position: 'fixed' as const,
    top: 0,
    left: 0,
    right: 0,
    bottom: 0,
    backgroundColor: 'rgba(0,0,0,0.45)',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    zIndex: 1300,
    padding: 16,
  },
  modal: {
    backgroundColor: '#fff',
    borderRadius: 16,
    padding: 24,
    maxWidth: '30%',
    width: '100%',
    position: 'relative' as const,
    boxShadow: '0 16px 48px rgba(0,0,0,0.12)',
    display: 'flex',
    flexDirection: 'column',
    gap: 24,
    boxSizing: 'border-box' as const,
    [theme.breakpoints.down('sm')]: {
      padding: 20,
      maxWidth: '100%',
      width: '100%',
    },
  },
  headerBlock: {
    display: 'flex',
    flexDirection: 'column',
    gap: 16,
    width: '100%',
  },
  headerTop: {
    display: 'flex',
    alignItems: 'flex-start',
    justifyContent: 'space-between',
    gap: 16,
    width: '100%',
  },
  close: {
    color: '#000a8d',
    padding: 4,
    flexShrink: 0,
    marginTop: -2,
    '&:hover': {
      backgroundColor: 'rgba(0, 10, 141, 0.06)',
    },
  },
  title: {
    fontFamily: 'Poppins',
    fontWeight: 600,
    fontSize: 24,
    lineHeight: '28px',
    color: '#000a8d',
    marginBottom: 0,
    flex: 1,
    minWidth: 0,
  },
  description: {
    fontFamily: 'Poppins',
    fontSize: 16,
    fontWeight: 400,
    lineHeight: 1.5,
    color: '#000000',
    marginBottom: 0,
    marginTop: 0,
  },
  card: {
    backgroundColor: '#f4f4f4',
    borderRadius: 8,
    padding: 16,
    marginBottom: 0,
    display: 'flex',
    flexDirection: 'column',
    gap: 12,
    width: '100%',
    boxSizing: 'border-box' as const,
  },
  cardLabel: {
    fontFamily: 'Poppins',
    fontSize: 16,
    fontWeight: 400,
    letterSpacing: '0.32px',
    color: '#000000',
    marginBottom: 0,
  },
  cardTitle: {
    fontFamily: 'Poppins',
    fontWeight: 500,
    fontSize: 16,
    letterSpacing: '0.32px',
    lineHeight: 1.4,
    color: '#000000',
    marginBottom: 0,
  },
  progressRow: {
    display: 'flex',
    alignItems: 'center',
    gap: 16,
    width: '100%',
  },
  progressBar: {
    flex: 1,
    height: 12,
    minWidth: 0,
    borderRadius: 24,
    overflow: 'hidden',
    position: 'relative' as const,
  },
  progressFill: {
    height: '100%',
    borderRadius: 24,
    background:
      'linear-gradient(90deg, rgb(20, 14, 134) 0%, rgb(91, 30, 109) 29.81%, rgb(199, 54, 71) 54.33%, rgb(235, 131, 53) 76.92%, rgb(254, 211, 41) 100%)',
    transition: 'width 0.3s ease',
  },
  progressBg: {
    position: 'absolute' as const,
    top: 0,
    left: 0,
    right: 0,
    bottom: 0,
    backgroundColor: '#d8d8d8',
    borderRadius: 24,
  },
  progressText: {
    fontFamily: 'Poppins',
    fontSize: 12,
    fontWeight: 400,
    letterSpacing: '0.24px',
    color: '#000000',
    whiteSpace: 'nowrap' as const,
  },
  actions: {
    display: 'flex',
    flexDirection: 'column',
    gap: 12,
    width: '100%',
    alignItems: 'stretch',
  },
  resumeButton: {
    background:
      'linear-gradient(84.62deg, rgb(14, 13, 136) 0.92%, rgb(201, 54, 70) 35.77%, rgb(244, 152, 48) 75.01%, rgb(254, 211, 41) 97.62%)',
    color: '#fff',
    borderRadius: 8,
    minHeight: 40,
    padding: '10px 24px',
    textTransform: 'none' as const,
    fontFamily: 'Poppins',
    fontSize: 14,
    fontWeight: 500,
    letterSpacing: '0.28px',
    marginBottom: 0,
    boxShadow: 'none',
    '&:hover': {
      opacity: 0.95,
      background:
        'linear-gradient(84.62deg, rgb(14, 13, 136) 0.92%, rgb(201, 54, 70) 35.77%, rgb(244, 152, 48) 75.01%, rgb(254, 211, 41) 97.62%)',
    },
  },
  restartButton: {
    borderRadius: 8,
    border: '1px solid #d8d8d8',
    borderColor: '#d8d8d8',
    color: '#000b33',
    textTransform: 'none' as const,
    fontFamily: 'Poppins',
    fontWeight: 500,
    fontSize: 14,
    letterSpacing: '0.28px',
    minHeight: 40,
    padding: '10px 24px',
    backgroundColor: '#fff',
    '&:hover': {
      backgroundColor: '#fafafa',
      borderColor: '#d8d8d8',
    },
  },
}));

export default useStyles;
